import 'dayjs/locale/id'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { getLocalStorage } from 'helpers/local-storage'

dayjs.extend(timezone)
dayjs.extend(utc)
interface IDateFormatter {
  date: string | Date
  format?: string
  timezone?: string
}

const dateFormatter = ({
  date,
  timezone,
  format = 'DD/MM/YYYY',
}: IDateFormatter): string => {
  const lng = getLocalStorage('i18nextLng') || 'id'
  dayjs.locale(lng)

  const formattedDate = dayjs(date)
  if (!timezone) return formattedDate.format(format)

  try {
    const dateFormat = formattedDate.tz(timezone).format(format)
    return dateFormat
  } catch (error) {
    return formattedDate.format(format)
  }
}

export const getFormatTimeDB = (
  date: Date | null | undefined,
  status: string,
) => {
  const time = dateFormatter({
    date: String(date),
    format: 'YYYY-MM-DD',
  })
  const newTime =
    time + (status !== 'end' ? 'T00:00:00Z' : 'T23:59:59Z')
  return newTime
}
export default dateFormatter
